import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { IStockFilter } from "../models/filters/stockFilter";
import { IStockForm } from "../models/forms/stockForm";
import { IStockPDTO } from "../models/dtos/stockPDTO";
import { apiCallWithAuth } from "../helper/apiManager";

export default class StockService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/Stock";

    protected static override  getUrlFilter<F extends IStockFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.code != undefined)
                url += `&Code=${filter.code}`;
            if(filter.articleId != undefined)
                url += `&ArticleId=${filter.articleId}`;
            if(filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
            if(filter.unityId != undefined)
                url += `&UnityId=${filter.unityId}`;
        }
        
        return url;
    }

    public static async resetStock(centerCodeSpecies:string)
        {
            try {
                let result = await apiCallWithAuth(this.mainUrl + `/reset?centerBusinessKey=${centerCodeSpecies}`);
                return this.ReturnObject(result);
            } catch (err) {
                return this.ReturnError(err);
            }
        }

    public static override toDTO(obj:IStockForm):IStockPDTO {
        const dto = super.toDTO(obj) as IStockPDTO;
        return dto;
    }
}